import api from './api';

interface IPostDocumentsAPIData {
  documents: {
    documentPD: File | null,
    documentIT: File | null,
    documentRP: File | null,
    documentRU: File | null,
  };
}

async function postDocumentsAPI({ documents }: IPostDocumentsAPIData) {
  Object.entries(documents).forEach(([documentName, document]) => {
    const formData = new FormData();
    if (document && typeof document === 'object') {
      formData.append('type', documentName.slice(-2));
      formData.append('file', document);
      api.post('/documents/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      });
    }
  });
}

export default postDocumentsAPI;
